import React from 'react'
import uuid from 'react-uuid'
import classes from './InvadersList.module.css'
import { Link } from 'react-router-dom'

import Invader from './Invader'

const InvadersList = (props) => {
  return (
    <ul className={classes.container}>
      {props.name
        .map((x, index) => (
          <div key={uuid()} className={classes.invader}>
            <div className={classes.linkInvader}>
              <Link to={`invader_number_${index + 1}`}>
                <Invader key={x} color={x.color} shape={x.shape} />
              </Link>
            </div>
          </div>
        ))
        .reverse()}
    </ul>
  )
}

export default InvadersList
